<div class="ui-g">
    <div class="ui-sm-12 ui-md-12 ui-lg-10 ui-xl-8">
        <p-panel header="{{ 'change_password' | translate }}" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
            <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()"  style="padding-top: 10px;">
                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="old_password-input" name="old_password" type="password" pInputText style="width: 100%;" formControlName="old_password">
                    <label for="old_password-input">{{ 'old_password' | translate }}</label>
                </span>
                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="new_password_one-input" name="new_password_one" type="password" pInputText style="width: 100%;" formControlName="new_password_one">
                    <label for="new_password_one-input">{{ 'new_password_one' | translate }}</label>
                </span>
                <span class="ui-float-label" style="margin-bottom: 20px;">
                    <input id="new_password_two-input" name="new_password_two" type="password" pInputText style="width: 100%;" formControlName="new_password_two">
                    <label for="new_password_two-input">{{ 'new_password_two' | translate }}</label>
                </span>
                <button pButton type="submit" [disabled]="!changePasswordForm.valid" label="{{ 'change_password' | translate }}" class="ui-button-info"></button>
            </form>
        </p-panel>
    </div>
</div>


